import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios, { FILE_URL } from '../api/axios';
import { toast } from 'react-toastify';
import { useTheme } from '../context/ThemeContext';
import { useTranslation } from 'react-i18next';

const Register = () => {
    const navigate = useNavigate();
    const { settings, darkMode } = useTheme();
    const { t, i18n } = useTranslation();

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    const [formData, setFormData] = useState({
        company_name: '',
        username: '', // Yetkili kişi
        phone: '',
        tax_number: '',
        tax_office: '',
        email: '',
        postal_code: '',
        address: '',
        country: 'Türkiye',
        city: '',
        password: ''
    });

    const citiesTR = [
        "Adana", "Adıyaman", "Afyonkarahisar", "Ağrı", "Amasya", "Ankara", "Antalya", "Artvin", "Aydın", "Balıkesir",
        "Bilecik", "Bingöl", "Bitlis", "Bolu", "Burdur", "Bursa", "Çanakkale", "Çankırı", "Çorum", "Denizli",
        "Diyarbakır", "Edirne", "Elazığ", "Erzincan", "Erzurum", "Eskişehir", "Gaziantep", "Giresun", "Gümüşhane", "Hakkari",
        "Hatay", "Isparta", "Mersin", "İstanbul", "İzmir", "Kars", "Kastamonu", "Kayseri", "Kırklareli", "Kırşehir",
        "Kocaeli", "Konya", "Kütahya", "Malatya", "Manisa", "Kahramanmaraş", "Mardin", "Muğla", "Muş", "Nevşehir",
        "Niğde", "Ordu", "Rize", "Sakarya", "Samsun", "Siirt", "Sinop", "Sivas", "Tekirdağ", "Tokat",
        "Trabzon", "Tunceli", "Şanlıurfa", "Uşak", "Van", "Yozgat", "Zonguldak", "Aksaray", "Bayburt", "Karaman",
        "Kırıkkale", "Batman", "Şırnak", "Bartın", "Ardahan", "Iğdır", "Yalova", "Karabük", "Kilis", "Osmaniye", "Düzce"
    ];

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.post('/auth/register', formData);
            toast.success(t('messages.register_success'));
            navigate('/login');
        } catch (error) {
            toast.error(error.response?.data?.message || t('messages.register_failed'));
        }
    };

    const logoSrc = darkMode && settings.logo_dark 
        ? `${FILE_URL}/${settings.logo_dark}`
        : settings.logo_light 
            ? `${FILE_URL}/${settings.logo_light}`
            : null;

    return (
        <div className="container-fluid min-vh-100 p-0 overflow-x-hidden bg-light position-relative">
            {/* Dil Seçeneği */}
            <div className="position-absolute top-0 end-0 p-4" style={{ zIndex: 10 }}>
                <div className="btn-group btn-group-sm shadow-sm bg-white rounded">
                    <button 
                        className={`btn ${i18n.language === 'tr' ? 'btn-primary' : 'btn-outline-primary'}`} 
                        onClick={() => changeLanguage('tr')}
                    >
                        TR
                    </button>
                    <button 
                        className={`btn ${i18n.language === 'fr' ? 'btn-primary' : 'btn-outline-primary'}`} 
                        onClick={() => changeLanguage('fr')}
                    >
                        FR
                    </button>
                </div>
            </div>

            <div className="row justify-content-center py-5">
                <div className="col-lg-8 col-xl-6">
                    <div className="card border-0 shadow-lg rounded-4 overflow-hidden">
                        <div className="card-body p-5">
                            <div className="text-center mb-5">
                                {logoSrc && (
                                    <img src={logoSrc} alt="Logo" className="mb-3" style={{ maxHeight: '60px' }} />
                                )}
                                <h2 className="fw-bold text-dark">{t('register.title')}</h2>
                                <p className="text-muted">{t('register.subtitle')}</p>
                            </div>

                            <form onSubmit={handleSubmit}>
                                <h5 className="text-primary border-bottom pb-2 mb-4">{t('register.company_info')}</h5>
                                <div className="row g-3 mb-4">
                                    <div className="col-md-6">
                                        <label className="form-label small fw-bold text-muted">{t('register.company_name')}</label>
                                        <input type="text" className="form-control" name="company_name" required onChange={handleChange} />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label small fw-bold text-muted">{t('register.authorized_person')}</label>
                                        <input type="text" className="form-control" name="username" required onChange={handleChange} />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label small fw-bold text-muted">{t('register.phone')}</label>
                                        <input type="text" className="form-control" name="phone" required onChange={handleChange} />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label small fw-bold text-muted">{t('register.email')}</label>
                                        <input type="email" className="form-control" name="email" required onChange={handleChange} />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label small fw-bold text-muted">{t('register.tax_number')}</label>
                                        <input type="text" className="form-control" name="tax_number" required onChange={handleChange} />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label small fw-bold text-muted">{t('register.tax_office')}</label>
                                        <input type="text" className="form-control" name="tax_office" required onChange={handleChange} />
                                    </div>
                                </div>

                                <h5 className="text-primary border-bottom pb-2 mb-4">{t('register.address_info')}</h5>
                                <div className="row g-3 mb-4">
                                    <div className="col-md-6">
                                        <label className="form-label small fw-bold text-muted">{t('register.country')}</label>
                                        <select className="form-select" name="country" value={formData.country} onChange={handleChange}>
                                            <option value="Türkiye">{t('settings.turkish')}</option>
                                            <option value="Almanya">Almanya</option>
                                            <option value="Amerika Birleşik Devletleri">Amerika Birleşik Devletleri</option>
                                            <option value="Fransa">{t('settings.french')}</option>
                                            <option value="Hollanda">Hollanda</option>
                                            <option value="İngiltere">İngiltere</option>
                                            <option value="Diğer">Diğer</option>
                                        </select>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label small fw-bold text-muted">{t('register.city')}</label>
                                        {formData.country === 'Türkiye' ? (
                                            <select className="form-select" name="city" required onChange={handleChange}>
                                                <option value="">{t('common.select')}</option>
                                                {citiesTR.map(city => <option key={city} value={city}>{city}</option>)}
                                            </select>
                                        ) : (
                                            <input type="text" className="form-control" name="city" required onChange={handleChange} />
                                        )}
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label small fw-bold text-muted">{t('register.postal_code')}</label>
                                        <input type="text" className="form-control" name="postal_code" required onChange={handleChange} />
                                    </div>
                                    <div className="col-md-8">
                                        <label className="form-label small fw-bold text-muted">{t('register.address')}</label>
                                        <input type="text" className="form-control" name="address" required onChange={handleChange} />
                                    </div>
                                </div>

                                <h5 className="text-primary border-bottom pb-2 mb-4">{t('register.security')}</h5>
                                <div className="row g-3 mb-4">
                                    <div className="col-md-12">
                                        <label className="form-label small fw-bold text-muted">{t('register.password')}</label>
                                        <input type="password" className="form-control" name="password" required onChange={handleChange} placeholder={t('profile.password_placeholder')} />
                                    </div>
                                </div>

                                <button type="submit" className="btn btn-primary w-100 btn-lg mb-3">{t('register.submit_btn')}</button>
                                <div className="text-center">
                                    <span className="text-muted">{t('register.has_account')} </span>
                                    <Link to="/login" className="text-decoration-none fw-bold">{t('register.login_link')}</Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Register;
